import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import OurRangeElectric from './OurRangeElectric.vue';
import debounce from 'lodash/debounce';

export default function (ourRangeElectricSection) {
    const ourRangeElectricSectionVueApp = ourRangeElectricSection.querySelector('.cms-content-our-range__vue-app');
    const ourRangeElectricSectionVueAppData = JSON.parse(ourRangeElectricSectionVueApp.dataset.vueAppData);
    Vue.use(Vuex);

    const selectedBrands = [];
    if (typeof window.location.search != 'undefined') {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('brand')) {
            selectedBrands.push(searchParams.get('brand'));
        }
    }

    const store = new Vuex.Store({
        state: {
            selectedOptions: {
                brand: selectedBrands,
                bodystyle: [],
                minPrice: null,
                maxPrice: null,
                minRange: null,
                maxRange: null,
                filters: ourRangeElectricSectionVueAppData,
            },
            availableOptions: {
                brand: [],
                bodystyle: [],
                minPrice: null,
                maxPrice: null,
                minRange: null,
                maxRange: null,
            },
            initialized: false,
            loadingOptions: true,
            loadingVehicles: true,
            vehicles: [],
            quoteValidDate: null,
        },
        actions: {
            getOptions:
                debounce(({ commit, state }) => {
                    commit('setLoadingOptions', true);
                    return new Promise((resolve, reject) => {
                        axios.get('/api/our-range-electric/options', {
                            params: state.selectedOptions
                        })
                            .then(response => {
                                commit('setLoadingOptions', false);
                                commit('setInitialized', true);
                                commit('setAvailableOptions', response.data);
                                resolve(response);
                            })
                            .catch(error => {
                                console.error('Error getting options');
                                console.error(error);
                                reject(error);
                            });
                    });
                },
                    350,
                    {
                        leading: false,
                        trailing: true
                    }
                ),
            getVehicles:
                debounce(({ commit, state }) => {
                    commit('setLoadingVehicles', true);
                    return new Promise((resolve, reject) => {
                        axios.get('/api/our-range-electric', {
                            params: state.selectedOptions
                        })
                            .then(response => {
                                commit('setLoadingVehicles', false);
                                commit('setQuoteValidDate', response.data.meta.quote_valid_date);
                                const vehicles = [];
                                response.data.data.forEach((vehicle) => {
                                    vehicles.push(vehicle);
                                });
                                commit('setVehicles', vehicles);
                                // setupFinance();
                                resolve(response);
                            })
                            .catch(error => {
                                console.error('Error getting vehicles');
                                console.error(error);
                                reject(error);
                            });
                    });
                },
                    350,
                    {
                        leading: false,
                        trailing: true
                    }
                ),
            getOptionsAndVehicles({ commit, dispatch }) {
                dispatch('getOptions');
                dispatch('getVehicles');
            },
            updateOptions({ commit, dispatch }, options) {
                commit('updateOptions', options);
                dispatch('getOptionsAndVehicles');
            },
        },
        mutations: {
            setAvailableOptions(state, options) {
                if (typeof options !== 'object') {
                    return false;
                }
                Object.keys(options).forEach(key => {
                    if (typeof state.availableOptions[key] == 'undefined') {
                        return;
                    }
                    if (key == 'type') {
                        const niceTypes = [];
                        options[key].forEach(type => {
                            niceTypes.push(type.charAt(0).toUpperCase() + type.slice(1));
                        })
                        state.availableOptions[key] = niceTypes;
                        return;
                    }
                    if (key == 'brand') {
                        const niceBrands = [];
                        options[key].forEach(brand => {
                            if (brand == 'ds') {
                                niceBrands.push('DS');
                                return;
                            }
                            niceBrands.push(brand.charAt(0).toUpperCase() + brand.slice(1));
                        })
                        state.availableOptions[key] = niceBrands;
                        return;
                    }
                    state.availableOptions[key] = options[key];
                });
            },
            updateOptions(state, options) {
                if (typeof options !== 'object') {
                    return false;
                }
                Object.keys(options).forEach(key => {
                    if (typeof state.selectedOptions[key] == 'undefined') {
                        return;
                    }
                    state.selectedOptions[key] = options[key];
                });
            },
            setVehicles(state, vehicles) {
                state.vehicles = vehicles;
            },
            setQuoteValidDate(state, quoteValidDate) {
                state.quoteValidDate = quoteValidDate;
            },
            setInitialized(state, initialized) {
                state.initialized = initialized;
            },
            setLoadingOptions(state, loadingOptions) {
                state.loadingOptions = loadingOptions;
            },
            setLoadingVehicles(state, loadingVehicles) {
                state.loadingVehicles = loadingVehicles;
            }
        }
    })

    const ourRangeElectricSectionVueAppVue = new Vue({
        el: ourRangeElectricSectionVueApp,
        store: store,
        components: {
            OurRangeElectric,
        },
    });
}